import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  getDoc,
  query,
  orderBy
} from 'firebase/firestore';
import { db } from './firebase';
import { Category, CategoryFormData } from '../types/category';

export const categoryService = {
  // Create a new category
  async createCategory(categoryData: CategoryFormData): Promise<string> {
    const category = {
      ...categoryData,
      createdAt: new Date()
    };

    const docRef = await addDoc(collection(db, 'categories'), category);
    return docRef.id;
  },

  // Get all categories
  async getCategories(): Promise<Category[]> {
    const q = query(collection(db, 'categories'), orderBy('name'));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate() || new Date()
    })) as Category[];
  },

  // Get a single category by ID
  async getCategoryById(id: string): Promise<Category | null> {
    const docRef = doc(db, 'categories', id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        id: docSnap.id,
        ...data,
        createdAt: data.createdAt?.toDate() || new Date()
      } as Category;
    }
    
    return null;
  },

  // Update a category
  async updateCategory(id: string, categoryData: CategoryFormData): Promise<void> {
    const docRef = doc(db, 'categories', id);
    await updateDoc(docRef, { ...categoryData });
  },

  // Delete a category
  async deleteCategory(id: string): Promise<void> {
    const docRef = doc(db, 'categories', id);
    await deleteDoc(docRef);
  }
}; 